var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgTech = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 20,
  height: 20,
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#tech_svg__a)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M13.03 7.195c-1.17-1.17-1.234-2.423 1.17-4.826a.201.201 0 0 0-.042-.319c-2.16-1.197-4.268-.92-6.046.857-1.668 1.668-2.014 3.628-1.06 5.649a.187.187 0 0 1-.046.218 60.25 60.25 0 0 0-2.517 2.347 60.21 60.21 0 0 0-2.347 2.517c-.887.995-1.078 2.544-.246 3.586.13.163.268.32.417.47.15.148.307.287.47.417 1.042.831 2.59.641 3.586-.247a60.2 60.2 0 0 0 2.517-2.346c.83-.83 1.602-1.683 2.347-2.517a.187.187 0 0 1 .218-.046c2.02.954 3.98.608 5.649-1.06 1.72-1.72 2.035-3.751.968-5.838a.133.133 0 0 0-.213-.032c-2.403 2.404-3.656 2.34-4.826 1.17Z",
  stroke: "#3A434A",
  strokeWidth: 1.5,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "tech_svg__a"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M0 0h20v20H0z"
})))));
export default SvgTech;